<div class="main">
  <H1>Help</H1>
  <div class="help-menu">
    <f-tabs uuid="awlds-help" [items]="filteredTabItems" (tabItemSelected)="onTabItemSelected($event)"></f-tabs>
  </div>

  @if (selectedView !== 'resource') {
  <div class="search-container">
    <f-text-input class="search-box" uuid="awlds-search" type="text" placeholder="Search"
      start-icon-config='{"iconName": "search", "iconType": "fal"}' (inputChanged)="onInputChanged($event)"
      (inputFocused)="onInputFocused($event)" (inputBlur)="onInputBlur($event)">
    </f-text-input>
    <f-button class="center" text="Search" variant="action" (buttonClicked)="onSearch()">
    </f-button>
  </div>
  }

  <div class="help-accordion" role="tabpanel" id="tabs-awlds-panel-123" [attr.aria-labelledby]="'tabs-awlds-tab-123'">
    @switch (selectedView) {
    @case ('faq') {
    @if (isFAQEnabled()) {
    <f-accordion>
      @for (faq of filteredFaqs; track faq.glossaryId) {
      <f-accordion-item text="{{faq.glossaryName}}">
        <p>{{faq.description}}</p>
      </f-accordion-item>
      }
    </f-accordion>
    }
    }
    @case ('glossary') {
    @if (isGlossaryEnabled()) {
    <app-alphabet-quickSearch (letterSelected)="filterByLetter($event)"></app-alphabet-quickSearch>
    <f-accordion>
      @for (term of filteredGlossary; track term.glossaryId) {
      <div class="glossary-container">
        <p class="glossary-name">{{ term.glossaryName }}</p>
        <p class="glossary-description">{{ term.description }}</p>
      </div>
      }
    </f-accordion>
    }
    }
    @case ('resource') {
    @if (isResourceEnabled()) {
    
    @if (!showPDFViewer) {
    <!-- Resource PDF List -->
    <div class="resource-pdf-list">
      @for (resource of filteredResourcePDFs; track resource.name) {
      <div class="resource-item" 
           (click)="selectResource(resource)">
        <i class="fal fa-file-pdf resource-icon"></i>
        <span class="resource-name">{{ resource.name }}</span>
        <i class="fal fa-chevron-right resource-arrow"></i>
      </div>
      }
    </div>

    <!-- Resources Section -->
    @if (filteredResources.length > 0) {
    <div class="glossary-resources-section">
      <h2 class="section-title">Additional Resources</h2>
      <f-accordion>
        @for (resource of filteredResources; track resource.glossaryId) {
        <div class="resource-container">
          <p class="resource-name">{{ resource.glossaryName }}</p>
          <p class="resource-description">{{ resource.description }}</p>
        </div>
        }
      </f-accordion>
    </div>
    }
    } @else {
    <!-- PDF Viewer with Back Button -->
    <div class="pdf-viewer-container">
      <div class="back-button-container">
        <f-button 
          variant="secondary" 
          start-icon-config='{"iconName": "arrow-left", "iconType": "fal"}'
          (buttonClicked)="backToResourceList()">
        </f-button>
        <h2 class="pdf-title">{{ selectedResourceName }}</h2>
      </div>
      
      <div class="pdf-viewer">
        @if (selectedResourceUrl) {
        <iframe [src]="selectedResourceUrl"
          style="border: 2px solid black; width: 100%; height: 816px; margin: 0 auto; display: block;">
        </iframe>
        }
      </div>
    </div>
    }
    }
    }
    }
  </div>
</div>